import * as React from "react";
import { BpoFooter } from "@duosoftbg/bpo-components";

const Footer = () => {
  return <BpoFooter />;
};
export default Footer;
